<template>
    <v-card v-if="controlInfo" class="execution-form-widget" flat>
        <v-card-text :class="getClassByStatus()">

            <div v-if="!!controlInfo.ControlDate" class="efw-title">
                <template>
                    <template>{{$t("Контрольный_срок")}}:</template>
                    <template> {{ controlInfo.ControlDate | formattedDate }}, {{ $t(resolutionStatus.text) }}</template>
                </template>
            </div>
            <div class="efw-desc-wrap">
                <div class="efw-description">
                    {{ $t(controlInfo.ControlType.Value) }}
                </div>
            </div>
            <div v-if="!!controlInfo.MainExecuterId" class="efw-desc-wrap">
                <div class="efw-description">{{ $t("Ответственный_исполнитель") }}:</div>
                <v-workplace-chip :id="controlInfo.MainExecuterId" :name="controlInfo.MainExecuterName" :main="true" />
            </div>
            
        </v-card-text>
    </v-card>
</template>

<script>
import sys from '@/services/system';

export default {
    classes: ["mdwi-gr-grey", "mdwi-gr-green", "mdwi-gr-aqua" ],
    name: "ResolutionStatusWidget",
    props: {
        controlInfo: {
            type: Object,
            default: null
        }
    },
    methods: {
        getClassByStatus() {
            var statusName = Object.keys(this.avaibleStatuses).find(key => this.avaibleStatuses[key] === this.resolutionStatus);
            
            switch (statusName)
            {
                case "executed":
                    return "mdwi-gr-green"; //зеленый
                
                case "needRework":
                    return "mdwi-gr-green-bordered"; // зеленый с красной чертой
                
                case "onExecution":
                    return "mdwi-gr-yellow"; //желтый

                case "onExecutionCheck":
                    return "mdwi-gr-orange"; //оранжевый
                
                case "expired":
                    return "mdwi-gr-aqua"; // красный

                case "new":
                case "redirected":
                case "redirectedControl":
                    return "mdwi-gr-purple"; // фиол

                default:
                    return "mdwi-gr-grey";
            }
        }
    },
    computed: {
        avaibleStatuses() {
            return this.$store.getters['documents/references/GetAvaibleStatuses'];
        },
        isControlDateToday() {
            let controlDate = this.$moment(this.controlInfo.ControlDate); 
            let currentTime = this.$moment(this.controlInfo.CurrentTime);

            if (!!controlDate && controlDate.isValid() && !!currentTime && currentTime.isValid()) {
                return controlDate.isSame(currentTime, 'day');
            }

            return false;
        },
        resolutionStatus() {
            return this.avaibleStatuses[this.$helpers.getTaskStatus(this.controlInfo.WorkStatus)];
        },
    },
    filters: {
        formattedDate: (value) => {
            var formatedDate = sys.dateFormat(value, 'DD.MM.YYYY');
            return formatedDate ?? "";
        }
    }
}
</script>